
import { Component, Mixins } from "vue-property-decorator";
import { ITableIndex } from "../../../../../../documaker/domain/format/objects";
import { ITableIndexPropertyPresentable, instanceOfITableIndexPropertyPresentable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TableIndexPropertyPresentableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITableIndexPropertyPresentable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITableIndexPropertyPresentable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTableIndexPresentable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITableIndexPropertyPresentable(s), false);
  }

  get isRootTableIndex(): boolean {
    return this.readPropertyOrDefault(s => s.tableIndex().getValue().row === 0 && s.tableIndex().getValue().column === 0, false);
  }

  get tableIndex(): ITableIndex {
    return this.readPropertyOrDefault(s => s.tableIndex().getValue(), { row: 0, column: 0 });
  }
}
